import React, { Component } from 'react'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'

class Slideshow extends Component {
    constructor(props) {
        super(props)
        this.state = {
            images: [],
            positions: [],
            image: 0
        }
    }
    
    componentWillReceiveProps = nextProps => this.setState({ images: nextProps.images, positions: nextProps.positions })
    
    componentDidMount = () => {
        this.interval = setInterval(this.startAnimation, 4000);
    }

    componentWillUnmount = () => {
        clearInterval(this.interval)
    }
    
    startAnimation = () => {
        this.setState({
          image: this.state.image === this.state.images.length - 1 ? 0 : this.state.image + 1
        })
    }
    
    render() {
        return(
            <div className="slideshow">
                <ReactCSSTransitionGroup transitionName="example" transitionEnterTimeout={1500} transitionLeaveTimeout={900}>
                    <div className="slideshow-image" style={{ backgroundImage: `url(https://uploads.newgroundworld.com/slides/${this.state.images[this.state.image]})`, backgroundPosition: `${this.state.positions[this.state.image]}` }} key={this.state.image}></div>
                </ReactCSSTransitionGroup>
            </div>
        )
    }
}

export default Slideshow


// WEBPACK FOOTER //
// ./src/components/Slideshow.js